export default "__VITE_ASSET__BdFkLdBJ__ 320w, __VITE_ASSET__DaREgaGu__ 480w, __VITE_ASSET__Dcb5H9iE__ 640w, __VITE_ASSET__DvDKYFqg__ 800w";